module.exports = __webpack_public_path__ + "static/14-1-ad8c02d5e8f1a799d4f5161b8e014e42.jpg";